import { useState } from 'react';
import { Button, TextField, Grid, Box, Typography, Alert, } from '@mui/material';
import { formToJson } from '../../../Utils/Common';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import { SingleSelector } from '../../../Component/MuiEx';
const EditBalance = (props) => {
    const { data, onSubmit, onClose } = props
    const [fieldErrors, setFieldErrors] = useState()
    const [error, setError] = useState()
    const [refundable, setRefundable] = useState(data.refundable)
    const [chargable, setChargable] = useState(data.chargable)

    // const session = getUserSession(apis)

    const handleSubmit = (event) => {
        setFieldErrors()
        setError()
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const postData = formToJson(form)
        postData.id = data ? data.id : 0
        postData.refundable = refundable
        postData.chargable = chargable
        onSubmit && onSubmit(postData, setError, setFieldErrors)
    };
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box sx={{ marginTop: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                <Typography component="h1" variant="h5">Add & Edit Role</Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }} autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <TextField defaultValue={data?.type} name="type" required fullWidth id="type" label="Balance Type"
                                error={fieldErrors && fieldErrors.type ? true : false}
                                helperText={fieldErrors && fieldErrors.type ? fieldErrors.type : ''}
                                autoFocus />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField defaultValue={data ? data.rate : 1} type="number" name="rate" fullWidth id="rate" label="Rate"
                                error={fieldErrors && fieldErrors.rate ? true : false}
                                helperText={fieldErrors && fieldErrors.rate ? fieldErrors.levrateel : ''}
                                autoFocus />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SingleSelector defaultValue={data.refundable} items={["Yes", "No"]} values={[1, 0]} label={"Can refund?"} onChange={(n, v) => { setRefundable(v) }} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SingleSelector defaultValue={data.chargable} items={["Yes", "No"]} values={[1, 0]} label={"Can charge course?"} onChange={(n, v) => { setChargable(v) }} />
                        </Grid>
                        {chargable == 1 && <Grid item xs={12} sm={12}>
                            <TextField defaultValue={data ? data.rate : 1} type="number" name="rate" fullWidth id="rate" label="Rate"
                                error={fieldErrors && fieldErrors.rate ? true : false}
                                helperText={fieldErrors && fieldErrors.rate ? fieldErrors.rate : ''}
                                autoFocus />
                        </Grid>}
                        {chargable == 1 && <Grid item xs={12} sm={12}>
                            <TextField defaultValue={data?.charge_order} type="number" name="charge_order" fullWidth id="charge_order" label="Payment Priority"
                                error={fieldErrors && fieldErrors.charge_order ? true : false}
                                helperText={fieldErrors && fieldErrors.charge_order ? fieldErrors.charge_order : ''}
                                autoFocus />
                        </Grid>}
                    </Grid>

                    {error && <Alert severity="error">{error}</Alert>}
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }} > Submit </Button>
                    <Button type="button" fullWidth variant="outlined" sx={{ mt: 1, mb: 2 }} onClick={() => { props.onClose && props.onClose(false) }}> Cancel </Button>
                </Box>
            </Box>
        </Container>
    );
}
export default EditBalance